import { stringify } from 'query-string';

import { GeneralLink } from '../models/Routes';
import { Network } from '../utils';

export class UserService {
  static async getUserInfo() {
    return Network.get('auth/me');
  }

  static login(location) {
    let redirectUrl = window.location.origin;
    if (location.pathname !== GeneralLink.ERROR) {
      redirectUrl = window.location.origin + location.pathname;
    }
    const ssoLoginUrl = `${process.env.REACT_APP_API_HOST}auth/azure/login?${stringify({ redirectUrl })}`;
    window.open(ssoLoginUrl, '_self');
  }

  static async logout() {
    document.cookie = 'connect.sid= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
    const ssoLogoutUrl = `${process.env.REACT_APP_API_HOST}auth/azure/logout`;
    window.open(ssoLogoutUrl, '_self');
  }

  static async updateWarningTime(warningTime: number, countryId: string) {
    await Network.patch(`countries/${countryId}`, { holdingTime: warningTime });
  }
}